import { render, staticRenderFns } from "./ContaForm.vue?vue&type=template&id=61c5dfa0&scoped=true"
import script from "./ContaForm.vue?vue&type=script&lang=js"
export * from "./ContaForm.vue?vue&type=script&lang=js"
import style0 from "./ContaForm.vue?vue&type=style&index=0&id=61c5dfa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c5dfa0",
  null
  
)

export default component.exports